"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyController = function (_context) { return ({
    pageReady: function () { },
    exports: {}
}); };
